import Vue from 'vue'
import './assets/style/reset.css'
import './assets/style/common.css'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import './utils/date'
import i18n from './i18n'
import { getParams, setAutograph } from '@/utils/index'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
const VueScrollTo = require('vue-scrollto')
// 获取地址栏参数，设置登录信息
const queryParams = getParams()
setAutograph(queryParams)

Vue.use(VueScrollTo)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
